<template>
  <footer id="contact" class="bg-black text-white py-10">
    <div class="max-w-7xl mx-auto px-6">
      <!-- Top: Contact + Links -->
      <div class="flex flex-col md:flex-row md:justify-between items-center gap-6 text-center md:text-left">
        
        <!-- Contact Info -->
        <div class="space-y-2">
          <p class="text-sm text-gray-400">Contact</p>
          <a href="mailto:joelegbertdev@gmail.com" class="text-white hover:text-bright-blue transition-colors mb-1">
            joelegbertdev@gmail.com
          </a>
          <br />
          <a href="https://t.me/egbertjoel" target="_blank" class="text-white hover:text-bright-blue transition-colors">
            Telegram @egbertjoel
          </a>
        </div>

        <!-- Quick Links -->
        <div class="space-y-2">
          <p class="text-sm text-gray-400">Quick Links</p>
          <div class="flex space-x-4 justify-center md:justify-start">
            <router-link to="/" class="hover:text-bright-blue">Home</router-link>
            <router-link to="/services" class="hover:text-bright-blue">Services</router-link>
            <router-link to="/about" class="hover:text-bright-blue">About</router-link>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="border-t border-gray-700 my-6"></div>

      <!-- Bottom: Copyright -->
      <div class="text-center text-gray-500 text-sm">
        &copy; {{ new Date().getFullYear() }} AlgoPilot. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComp",
};
</script>
